import { Heading as NxHeading } from '@nx-kit/heading';
import { HeadingProps } from './Heading.types';

export const Heading = (props: HeadingProps) => {
  return <NxHeading {...props} />;
};
